import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestDeleteSharingSchedule } from "./deleteSharingSchedule.request";

const useDeleteSharingSchedule = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestDeleteSharingSchedule,
    ...options
  });
};

export default useDeleteSharingSchedule;
